module.exports = __webpack_public_path__ + "img/logo_footer_hidalgo.80e7ce68.png";